/**
 * @file index.tsx
 *
 * @fileoverview A component that places the children in the page frame. With a max width.
 */

import { cva } from "class-variance-authority";
import { ReactNode } from 'react';
import styles from "../main.module.scss";

const mainWrapper = cva([styles.mainWrapper], {
  variants: {
    sideBlockCollapsed: {
      true: styles.mainWrapperSideBlockCollapsed,
    },
  },
});
export interface MainWithSideBlockProps {
  /**
   * Contents to show inside.
   */
  children: ReactNode;
  /**
   * IF the sideblock is collapsed.
   */
  sideBlockCollapsed: boolean;
}

/**
 * Renders content with a max width on the center of the page. Useful for placing
 * main content on a normal page.
 */
export const MainWithSideBlock = ({
  children,
  sideBlockCollapsed,
}: MainWithSideBlockProps) => {
  return <div className={mainWrapper({ sideBlockCollapsed })}>{children}</div>;
};

export default MainWithSideBlock;
